// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","box":"L9Fz4"};